import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const BOM = () => {
  return <ErpTablePage moduleKey="inv_bom" />;
};

export default BOM;